<div class="container-fluid py-4 px-4">

  <div class="container-fluid container-card mb-4">
    <h1 class="heading-1">Profile </h1>

    <div class="row my-5">
      <div class="col-12 col-md-6 col-lg-3 d-flex justify-content-center">
        <img [src]="itemPicture" alt="" class="rounded-circle border-light"
          style="width: 200px; height: 200px; object-fit: cover;">
      </div>

      <div class="col-12 col-md-6 col-lg-5">
        <div class="d-flex flex-column mb-3">
          <div class="title-text">Name</div>
          <div class="title-bold">{{ itemCurrentUser.name }}</div>
        </div>

        <div class="d-flex flex-column mb-3">
          <div class="title-text">Role</div>
          <div class="title-bold">{{ itemCurrentUser.roles }}</div>
        </div>

        <div class="d-flex flex-column mb-3">
          <div class="title-text">Email</div>
          <div class="title-bold"> {{ itemCurrentUser.email }}</div>
        </div>
      </div>

      <div class="col-12 col-md-12 mt-4 col-lg-4 d-flex align-items-center">
        <button class="btn btn-change-password" data-bs-toggle="modal" data-bs-target="#modalInputChangePassword">
          <i class="bi bi-shield-lock"></i> Change Password
        </button>
      </div>
    </div>
  </div>

  <div class="modal fade custom-modal" id="modalInputChangePassword" #modalChangePassword aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title header-title">Change Password</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btnCloseChangePassword"
            [disabled]="isLoading"></button>
        </div>
        <div class="modal-body my-2">
          <form #passwordForm="ngForm">
            <div class="form-group">
              <label for="currentPassword" class="title-body">Current Password <span
                  class="text-danger">*</span></label>
              <div class="input-group">
                <input [type]="showCurrentPassword ? 'text' : 'password'" class="form-control custom-form-control"
                  id="currentPassword" name="currentPassword" placeholder="Current Password"
                  [(ngModel)]="currentPassword" [disabled]="isLoading" required>
                <div class="input-group-text cursor-pointer" (click)="toggleCurrentPasswordVisibility()"
                  [class.disabled]="isLoading">
                  <i class="" [ngClass]="showCurrentPassword ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                </div>
              </div>
            </div>

            <div class="form-group my-2">
              <label for="newPassword" class="title-body">New Password <span class="text-danger">*</span></label>
              <div class="input-group">
                <input [type]="showNewPassword ? 'text' : 'password'" class="form-control custom-form-control"
                  id="newPassword" name="newPassword" placeholder="New Password" [(ngModel)]="newPassword"
                  [disabled]="isLoading" required minlength="6">
                <div class="input-group-text cursor-pointer" (click)="toggleNewPasswordVisibility()"
                  [class.disabled]="isLoading">
                  <i class="" [ngClass]="showNewPassword ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                </div>
              </div>
              <small class="form-text text-muted">Password must be at least 6 characters long</small>
            </div>

            <div class="form-group my-2">
              <label for="confirmPassword" class="title-body">Confirm Password <span
                  class="text-danger">*</span></label>
              <div class="input-group">
                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control custom-form-control"
                  id="confirmPassword" name="confirmPassword" placeholder="Confirm Password"
                  [(ngModel)]="confirmPassword" [disabled]="isLoading" required>
                <div class="input-group-text cursor-pointer" (click)="toggleConfirmPasswordVisibility()"
                  [class.disabled]="isLoading">
                  <i class="" [ngClass]="showConfirmPassword ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                </div>
              </div>
            </div>

            <!-- Password strength indicator (optional) -->
            <div class="form-group my-2" *ngIf="newPassword.length > 0">
              <small class="form-text">
                <span [ngClass]="{
                  'text-danger': newPassword.length < 6,
                  'text-warning': newPassword.length >= 6 && newPassword.length < 8,
                  'text-success': newPassword.length >= 8
                }">
                  Password strength:
                  <span *ngIf="newPassword.length < 6">Weak</span>
                  <span *ngIf="newPassword.length >= 6 && newPassword.length < 8">Fair</span>
                  <span *ngIf="newPassword.length >= 8">Strong</span>
                </span>
              </small>
            </div>

            <div class="row mt-5 mb-2">
              <div class="col-6 col-md-6 col-lg-6">
                <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" [disabled]="isLoading">
                  Cancel
                </button>
              </div>
              <div class="col-6 col-md-6 col-lg-6">
                <button type="button" class="btn btn-save" (click)="showPasswordModal()"
                  [disabled]="isLoading || !passwordForm.form.valid">

                  <!-- Loading spinner -->
                  <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>

                  <!-- Button text -->
                  <span *ngIf="!isLoading">Save</span>
                  <span *ngIf="isLoading">Saving...</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
